import { render } from "./VersionSelector.vue?vue&type=template&id=32f6c28e&scoped=true"
import script from "./VersionSelector.vue?vue&type=script&lang=js"
export * from "./VersionSelector.vue?vue&type=script&lang=js"

import "./VersionSelector.vue?vue&type=style&index=0&id=32f6c28e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32f6c28e"]])

export default __exports__